import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { CSVLink } from 'react-csv';
import { useDispatch, useSelector } from 'react-redux';
import ReactToPrint from 'react-to-print';
import { IReducer } from '../../../../../../redux/configureStore';
import {
  DownloadReport,
  Loading,
} from '../../../../../../shared/components/buttons/SearchButton';
import Wrapper from '../../../../../../shared/components/Wrapper';
import UnifiedReportPdf from '../UnifiedReport/components/ExportPdf/components/UnifiedReportPdf';
import SetMonthEnd from './FilterModal/components/SetMonthEnd';
import SetMonthInitial from './FilterModal/components/SetMonthInitial';
import unifiedReportCsvData from './FilterModal/data';
import { checkTwoDate } from './FilterModal/functions';

const validationRedenring = (e, l) => {
  if (e === '' || l === '') {
    return (
      <DownloadReport
        justifyContent="center"
        backgroundColor="#a4a4a4"
        width="136px"
      />
    );
  }
  return <Loading justifyContent="center" width="136px" />;
};

function UnifiedReportSmartExcel({ show, onHide }: any) {
  const dispatch = useDispatch();
  const [initial, setInitial] = useState('');
  const [end, setEnd] = useState('');
  const [fare] = useState('fiducia');
  const accountingAppContext = useSelector(
    (reducer: IReducer) => reducer.accountingAppV2
  );

  useEffect(() => {
    if (initial !== '' && end !== '') {
      checkTwoDate(initial, end, fare, dispatch);
    }
  }, [initial, end, fare, dispatch]);

  const database: any = unifiedReportCsvData();

  const header = [
    { label: 'Terceiros: Tipo', key: 'partnersType' },
    { label: 'Terceiros: Operação', key: 'partnersLabels' },
    { label: 'Terceiros: Valores', key: 'partnersValues' },
    { label: '', key: '' },
    { label: 'Fidúcia: Tipo', key: 'fiduciaType' },
    { label: 'Fidúcia: Operação', key: 'fiduciaLabels' },
    { label: 'Fidúcia: Valores', key: 'fiduciaValues' },
  ];

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="xl"
      style={{
        borderRadius: '10px 10px 0px 0px',
        display: 'block',
        maxWidth: '550px',
        margin: 'auto',
        left: '50%',
        transform: 'translate(-50%,0%)',
      }}
      aria-labelledby="contained-modal-title-vcenter"
      centered>
      <Modal.Header
        style={{
          background: '#125C5B',
          color: '#fff',
          fontStyle: 'normal',
          display: 'flex',
          justifyContent: 'center',
        }}>
        <Modal.Title
          style={{
            fontSize: '22px',
            lineHeight: '26px',
            textAlign: 'center',
            fontWeight: 'bold',
          }}
          id="contained-modal-title-vcenter">
          Download do relatório unificado em Excel
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Wrapper.Default isActive flexDirection="row">
          <SetMonthInitial setDate={setInitial} date={initial} />
          <SetMonthEnd setDate={setEnd} date={end} />
        </Wrapper.Default>
      </Modal.Body>
      <Modal.Footer
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          width: '100%',
          border: 'none',
        }}>
        <Wrapper.Button onClick={onHide}>Fechar</Wrapper.Button>

        {!accountingAppContext.isLoading ? (
          <CSVLink
            data={database}
            headers={header}
            filename="Relatório contábil.csv">
            <DownloadReport justifyContent="center" width="136px" />
          </CSVLink>
        ) : (
          validationRedenring(initial, end)
        )}
      </Modal.Footer>
    </Modal>
  );
}

export function UnifiedReportSmartPdf({ show, onHide }: any) {
  const dispatch = useDispatch();
  const [initial, setInitial] = useState('');
  const [end, setEnd] = useState('');
  const [fare] = useState('fiducia');
  const componentRef: any = React.useRef();

  const accountingAppContext = useSelector(
    (reducer: IReducer) => reducer.accountingAppV2
  );

  useEffect(() => {
    if (initial !== '' && end !== '') {
      checkTwoDate(initial, end, fare, dispatch);
    }
  }, [initial, end, fare, dispatch]);

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="xl"
      style={{
        borderRadius: '10px 10px 0px 0px',
        display: 'block',
        maxWidth: '550px',
        margin: 'auto',
        left: '50%',
        transform: 'translate(-50%,0%)',
      }}
      aria-labelledby="contained-modal-title-vcenter"
      centered>
      <div style={{ display: 'none' }}>
        <UnifiedReportPdf data={accountingAppContext} ref={componentRef} />
      </div>
      <Modal.Header
        style={{
          background: '#125C5B',
          color: '#fff',
          fontStyle: 'normal',
          display: 'flex',
          justifyContent: 'center',
        }}>
        <Modal.Title
          style={{
            fontSize: '22px',
            lineHeight: '26px',
            textAlign: 'center',
            fontWeight: 'bold',
          }}
          id="contained-modal-title-vcenter">
          Download do relatório unificado em Pdf
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Wrapper.Default isActive flexDirection="row">
          <SetMonthInitial setDate={setInitial} date={initial} />
          <SetMonthEnd setDate={setEnd} date={end} />
        </Wrapper.Default>
      </Modal.Body>
      <Modal.Footer
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          width: '100%',
          border: 'none',
        }}>
        <Wrapper.Button onClick={onHide}>Fechar</Wrapper.Button>

        {!accountingAppContext.isLoading ? (
          <ReactToPrint
            trigger={() => {
              return <DownloadReport justifyContent="center" width="136px" />;
            }}
            content={() => componentRef.current}
          />
        ) : (
          validationRedenring(initial, end)
        )}
      </Modal.Footer>
    </Modal>
  );
}

export default UnifiedReportSmartExcel;
